import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getProductByName} from 'api/requests';
import {IProductByNameRequest, IProductByNameResponse, QueryKeyEnum} from 'types';

export const useProductByName = (
  queryKey: QueryKey,
  query: IProductByNameRequest,
  options: UseQueryOptions<IProductByNameResponse>,
) => {
  return useQuery<IProductByNameResponse>({
    queryKey: [QueryKeyEnum.PRODUCT_BY_CATEGORY],
    queryFn: () => getProductByName(query),
    ...options,
  });
};
